module.exports = __webpack_public_path__ + "img/boys.f6db30ba.png";